<template>
  <v-card flat class="ma-2">
    <v-card-text class="pt-0">
      <v-layout align-center class="mt-3">
        <v-flex>
          <v-layout align-center>
            <v-icon color="primary" class="mr-2">battery_charging_full</v-icon>
            <span class="subheading">{{ $t('lithiumBattery') }}</span>
            <v-chip v-if="props.item.lithiumBatteryOptions && props.item.lithiumBatteryOptions.length > 0" small color="primary" text-color="white" class="ml-3">
              {{ props.item.lithiumBatteryOptions.length }} {{ $t('selected') }}
            </v-chip>
            <v-tooltip bottom max-width="400">
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" color="primary" class="ml-2">help</v-icon>
              </template>
              <div>{{ $t('lithiumBatteriesHelp') }}</div>
            </v-tooltip>
            <!-- apply all -->
            <v-btn
              color="primary"
              small
              dark
              flat
              @click="
                applyAll(
                  props.item
                )
              "
            >
              {{ $t('applyToAll') }}
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout column class="ml-4 mt-3">
        <v-flex v-for="option in lithiumBatteryOptionItems" :key="option.value">
          <v-flex md4 xs5 xl3>
            <v-layout align-center>
              <v-checkbox
                :label="option.label"
                :value="option.value"
                v-model="props.item.lithiumBatteryOptions"
                hide-details
                class="mt-0 mb-1"
                dense>
              </v-checkbox>
              <v-spacer></v-spacer>
              <v-tooltip bottom max-width="300">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="primary" small>help</v-icon>
                </template>
                <div>{{ option.tooltip }}</div>
              </v-tooltip>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    lithiumBatteryOptionItems: {
      type: Array,
      default: () => []
    },
    props: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    applyAll (item) {
      this.$emit('applyAll', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LithiumBatteryDangerousGoods.vue